import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../components/header/Header";
import { checkParams } from "../../../src/util/Util";
import "./Verify.css";

const Verify = (props) => {
  let navigate = useNavigate();
  const [isOpenNewEmail, setOpenNewEmail] = useState(false);
  const [email, setEmail] = useState(
    localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData")).email
      : ""
  );
  // eslint-disable-next-line
  const [phone, setPhone] = useState(
    localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData")).phone
      : ""
  );
  const [changeEmail, setChangeEmail] = useState(false);
  const [errorEmail, setErrorEmail] = useState("");
  const [messageActive, setMessageActive] = useState(false);
  const [code, setCode] = useState("");
  const [errorCode, setErrorCode] = useState("");

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
    localStorage.removeItem("userCompanyData");
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios.post(window.ajaxLink + "user/checkOtpVerified", {}).catch((error) => {
      console.error(error);
      resendCode(true);
    });
    // eslint-disable-next-line
  }, []);

  const setNewEmail = () => {
    if (!checkParams(changeEmail, "email")) {
      setErrorEmail("Please enter a valid email address.");
    } else {
      setErrorEmail("");
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "user/setNewEmail", {
          firstName: JSON.parse(localStorage.getItem("userData"))
            ? JSON.parse(localStorage.getItem("userData")).first_name
            : "Virdio User",
          oldEmail: email,
          newEmail: changeEmail.trim().toLowerCase(),
        })
        .then((res) => {
          if (res.data.responseCode === 200) {
            var newMail = JSON.parse(localStorage.getItem("userData"));
            newMail.email = changeEmail;
            localStorage.setItem("userData", JSON.stringify(newMail));
            props.checkLoggedIn(true);
            setEmail(changeEmail);
            setOpenNewEmail(false);
            setMessageActive(true);
            setChangeEmail("");
            resendCode();
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.errorData.emailErr) {
            setErrorEmail(error.response.data.errorData.emailErr);
          }
        });
    }
  };

  const resendCode = (onload) => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "user/resendOtp", {
        firstName: JSON.parse(localStorage.getItem("userData"))
          ? JSON.parse(localStorage.getItem("userData")).first_name
          : "Virdio User",
        email: email,
      })
      .then((res) => {
        if (res.data.responseCode === 200) {
          //localStorage.setItem("userData", JSON.stringify(res.data.responseData));
          props.checkLoggedIn(true);
          if (!onload) {
            setMessageActive(true);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const verifyOtp = () => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "user/verifyOtp", {
        code: code,
      })
      .then((res) => {
        if (res.data.responseCode === 200) {
          props.checkLoggedIn(true);
          if (res.data.responseData.token && res.data.responseData.self_user == 1) {
			const fromSite = localStorage.getItem("fromSite") || 'https://www.startfreept.com';
            window.location.href = fromSite + `/?userId=${res.data.responseData.id}&userToken=${res.data.responseData.token}`;
            return;
          }

          if (res.data.responseData.userType === 1) {
            navigate("/initial_questionare");
            localStorage.removeItem("company_id");
          } else if (res.data.responseData.userType === 2) {
            navigate("/dashboard");
          }
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.errorData.codeErr) {
          setErrorCode(error.response.data.errorData.codeErr);
        }
      });
  };

  return (
    <div style={{ paddingBottom: "2rem" }}>
      {messageActive && (
        <div className="header_resent">
          <div className="verify_msg_box"></div>
          <div className="verify_hdr_text">
            A verification code has been resent to
            <span>{" {" + email + "}. "}</span>
            Please enter it once you receive the email
          </div>
          <div
            className="verify_hdr_text verify_hdr_dis"
            onClick={() => setMessageActive(false)}
          >
            Dismiss
          </div>
        </div>
      )}
      <Header />
      <div
        className={
          "verify_container" + (messageActive ? " verify_cont_msg_active" : "")
        }
      >
        <div
          className="previous_btn verify_prev_button"
          onClick={() =>
            navigate(localStorage.getItem("isNew") ? "/register" : "/login")
          }
        >
          <div className="back_arrow_btn"></div>
        </div>
        <div className="cloud_verify_holder">
          <div className="verify_title">Verify your account</div>
          <div className="verify_explain">
            We've sent an email with a code to <span>[{email}]</span> and SMS to
            mobile number <span>[{phone}]</span> to verify your Virdio Health
            account.
          </div>
          <div className="verify_form_title">Security code</div>
          <input
            type="text"
            tabIndex="1"
            className="reg_input verify_input"
            onChange={(e) => setCode(e.target.value)}
          />
          {errorCode && (
            <div className="email_error_msg email_error_pdng_bottom">
              {errorCode}
            </div>
          )}
          <div className="verify_actions">
            <div className="verify_action_desc">Didn’t receive the code?</div>
            <div className="verify_action_trigger" onClick={() => resendCode()}>
              Resend Code
            </div>
          </div>
          <div className="verify_actions">
            <div className="verify_action_desc">Wrong email?</div>
            <div
              className="verify_action_trigger"
              onClick={() => setOpenNewEmail(true)}
            >
              Change email address
            </div>
          </div>
          <div className="verify_info">
            <div className="verify_info_inner">
              <div className="verify_info_left">
                <div className="verify_info_sign"></div>
              </div>
              <div className="verify_info_text_box">
                Please make sure to check your tabs Updates, Promotions, Forums,
                and Spam Folder
              </div>
            </div>
          </div>
          <div
            className={
              "signNewButton" + (code.length > 0 ? "" : " reg_procc_disabled")
            }
            onClick={() => verifyOtp()}
          >
            Continue
          </div>
        </div>
      </div>
      {isOpenNewEmail && (
        <div className="dlt_wrapper">
          <div className="change_mail_place_on_page">
            <div className="change_mail_surround">
              <div
                className="cm_close"
                onClick={() => setOpenNewEmail(false)}
              ></div>
              <div className="cm_title">Change Email Address</div>
              <div className="cm_explain">
                Enter email below. We’ll send you an email with a code to this
                new address.
              </div>
              <div className="verify_form_title cm_form_title">
                Email Address
              </div>
              <input
                type="text"
                className="reg_input cm_input"
                placeholder="Enter Email Address"
                onChange={(e) => setChangeEmail(e.currentTarget.value)}
              />
              {errorEmail && (
                <div className="email_error_msg email_error_pdng_bottom">
                  {errorEmail}
                </div>
              )}
              <div className="cm_confirm" onClick={() => setNewEmail()}>
                Send
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Verify;
